import React, { useEffect, useState } from "react";
import { message, Upload } from "antd";

const UploadImage = ({ profile_picture, handleUploadImage }) => {
  const [fileList, setFileList] = useState([]);

  const handleUpload = async (file) => {
    const base64Image = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
    handleUploadImage(base64Image);
  };

  const onChange = ({ fileList: newFileList }) => {
    // Check if a new file is added
    if (newFileList.length > fileList.length) {
      const newFile = newFileList[newFileList.length - 1];
      if (newFile.originFileObj) {
        // Validate file type and size
        const isValidType = newFile.originFileObj.type.startsWith("image/");
        const isValidSize = newFile.originFileObj.size / 1024 / 1024 < 2; // 2MB limit

        if (!isValidType) {
          message.error("You can only upload image files!");
          return;
        }

        if (!isValidSize) {
          message.error("Image must be smaller than 2MB!");
          return;
        }

        handleUpload(newFile.originFileObj);
      }
    }
    setFileList(newFileList);
  };

  const handleDeleteFile = () => {
    handleUploadImage("");
  };

  useEffect(() => {
    if (profile_picture) {
      setFileList([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: profile_picture,
        },
      ]);
    }
  }, [profile_picture]);

  return (
    <Upload
      listType="picture-circle"
      fileList={fileList}
      onChange={onChange}
      onRemove={handleDeleteFile}
      multiple={false}
      accept="image/*"
    >
      {fileList.length === 0 && "+ Upload"}
    </Upload>
  );
};
export default UploadImage;
